import I1 from "../img/i1.jpg";
import F1 from "../img/f1.jpg";
import C3 from "../img/c3.jpg";
import Fi1 from "../img/fi1.jpg";

export const heroData = [
  {
    id: 1,
    name: "SMALL",
    decp: "HOME SETUP",
    price: "2500",
    imageSrc: I1,
  },
  {
    id: 2,
    name: "MEDIUM ",
    decp: "TERACE SETUP",
    price: "5000",
    imageSrc: F1,
  },
  {
    id: 3,
    name: "LARGE ",
    decp: "MEDIUM AREA",
    price: "10000",
    imageSrc: C3,
  },
  {
    id: 4,
    name: "EXTRA LARGE",
    decp: "LARGE AREA",
    price: "20000",
    imageSrc: Fi1,
  },
];

export const categories = [
  {
    id: 1,
    name: "Setup",
    urlParamName: "SETUP",
  },
  {
    id: 2,
    name: "Plants",
    urlParamName: "plants",
  },
  {
    id: 3,
    name: "Fish",
    urlParamName: "fish",
  },
  {
    id: 4,
    name: "Fruits",
    urlParamName: "fruits",
  },
];
